import type { Person } from '../types/people';
import AvatarStack from './AvatarStack';

interface AssigneeDropdownProps {
  people: Person[];
  value: string | null;
  onChange: (personId: string | null) => void;
  placeholder?: string;
  style?: React.CSSProperties;
}

export default function AssigneeDropdown({
  people,
  value,
  onChange,
  placeholder = 'Who is responsible?',
  style,
}: AssigneeDropdownProps) {
  return (
    <select
      value={value ?? ''}
      onChange={(e) => onChange(e.target.value || null)}
      style={{
        width: '100%',
        padding: '10px 12px',
        border: '1px solid var(--color-border)',
        borderRadius: 'var(--radius)',
        ...style,
      }}
    >
      <option value="">{placeholder}</option>
      {people.map((person) => (
        <option key={person.id} value={person.id}>
          {person.name}
        </option>
      ))}
    </select>
  );
}

export function AssigneeDisplay({
  people,
  assigneeId,
  showAvatar = false,
}: {
  people: Person[];
  assigneeId: string | null;
  showAvatar?: boolean;
}) {
  if (!assigneeId) return <>—</>;
  const person = people.find((p) => p.id === assigneeId);
  if (!person) return <>{assigneeId}</>;
  if (showAvatar) {
    return <AvatarStack people={people} personIds={[assigneeId]} size={20} />;
  }
  return <>{person.name}</>;
}

export function AssigneesDisplay({
  people,
  assigneeIds,
}: {
  people: Person[];
  assigneeIds: string[];
}) {
  if (!assigneeIds || assigneeIds.length === 0) {
    return <>—</>;
  }
  return <AvatarStack people={people} personIds={assigneeIds} size={20} />;
}
